(function() {
    'use strict';

    var registry = window.PooleaseSectionScripts = window.PooleaseSectionScripts || {};
    if (registry.socialProof) {
      registry.socialProof(document);
      return;
    }
    var SECTION_SELECTOR = '[data-social-proof-slider]';

    function initSocialProof(section) {
      if (!section || section.dataset.socialProofInitialized === 'true') return;

      var viewport = section.querySelector('[data-slider-viewport]');
      var track = section.querySelector('[data-slider-track]');
      var slides = Array.from(section.querySelectorAll('[data-slide-index]'));
      var previousButton = section.querySelector('[data-slider-previous]');
      var nextButton = section.querySelector('[data-slider-next]');
      var dialog = section.querySelector('[data-video-dialog]');
      var dialogTitle = section.querySelector('[data-dialog-title]');
      var dialogVideo = section.querySelector('[data-dialog-video]');
      var dialogSource = section.querySelector('[data-dialog-source]');
      var closeButton = section.querySelector('[data-dialog-close]');
      if (!viewport || !track || !slides.length || !previousButton || !nextButton || !dialog || !dialogVideo) return;

      var currentIndex = 0;
      var scrollFrame = 0;
      var lastTrigger = null;
      var previousBodyOverflow = '';
      var resizeObserver = null;
      var usesDialogFallback = false;
      var dialogSessionActive = false;

      section.dataset.socialProofInitialized = 'true';

      function updateControls(index) {
        currentIndex = Math.max(0, Math.min(index, slides.length - 1));
        var maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        var atStart = viewport.scrollLeft <= 1;
        var atEnd = maxScroll <= 1 || viewport.scrollLeft >= maxScroll - 1;
        previousButton.disabled = atStart;
        nextButton.disabled = atEnd;
      }

      function getSlideLeft(slide) {
        return slide.offsetLeft - track.offsetLeft;
      }

      function getNearestIndex() {
        var target = viewport.scrollLeft;
        var nearestIndex = 0;
        var nearestDistance = Infinity;

        slides.forEach(function(slide, index) {
          var distance = Math.abs(getSlideLeft(slide) - target);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        return nearestIndex;
      }

      function goToSlide(index) {
        var nextIndex = Math.max(0, Math.min(index, slides.length - 1));
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        viewport.scrollTo({
          left: getSlideLeft(slides[nextIndex]),
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
        updateControls(nextIndex);
      }

      function handleScroll() {
        if (scrollFrame) return;
        scrollFrame = window.requestAnimationFrame(function() {
          scrollFrame = 0;
          updateControls(getNearestIndex());
        });
      }

      function clearDialogVideo() {
        dialogVideo.pause();
        dialogVideo.removeAttribute('src');
        dialogVideo.removeAttribute('poster');
        dialogVideo.querySelectorAll('source, track').forEach(function(mediaChild) {
          mediaChild.remove();
        });
        if (dialogSource) {
          dialogSource.hidden = true;
          dialogSource.removeAttribute('href');
          dialogSource.textContent = '';
        }
        dialogVideo.load();
      }

      function closeDialog() {
        if (!dialog.open) return;

        if (!usesDialogFallback && typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
          finishDialogClose();
        }
      }

      function finishDialogClose() {
        if (!dialogSessionActive) return;
        dialogSessionActive = false;
        clearDialogVideo();
        document.body.style.overflow = previousBodyOverflow;
        if (lastTrigger) lastTrigger.focus();
      }

      function openDialog(trigger) {
        var card = trigger.closest('[data-slide-index]');
        var sourceTemplate = card ? card.querySelector('[data-video-sources]') : null;
        if (!sourceTemplate) return;

        clearDialogVideo();
        lastTrigger = trigger;
        if (dialogTitle) dialogTitle.textContent = trigger.dataset.videoLabel || 'Customer video';
        if (trigger.dataset.videoPoster) dialogVideo.poster = trigger.dataset.videoPoster;
        if (dialogSource && trigger.dataset.sourceUrl) {
          dialogSource.href = trigger.dataset.sourceUrl;
          dialogSource.textContent = trigger.dataset.sourceLabel || 'View original post';
          dialogSource.hidden = false;
        }
        dialogVideo.appendChild(sourceTemplate.content.cloneNode(true));
        previousBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        dialogSessionActive = true;

        if (typeof dialog.showModal === 'function') {
          usesDialogFallback = false;
          dialog.showModal();
        } else {
          usesDialogFallback = true;
          dialog.setAttribute('open', '');
        }

        dialogVideo.load();
        var playPromise = dialogVideo.play();
        if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function() {});
        window.requestAnimationFrame(function() {
          dialogTitle.focus();
        });
      }

      previousButton.addEventListener('click', function() {
        goToSlide(getNearestIndex() - 1);
      });

      nextButton.addEventListener('click', function() {
        goToSlide(getNearestIndex() + 1);
      });

      viewport.addEventListener('scroll', handleScroll, { passive: true });
      viewport.addEventListener('keydown', function(event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goToSlide(currentIndex - 1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          goToSlide(currentIndex + 1);
        }
      });

      section.querySelectorAll('[data-video-trigger]').forEach(function(trigger) {
        trigger.addEventListener('click', function() {
          openDialog(trigger);
        });
      });

      closeButton.addEventListener('click', closeDialog);
      dialog.addEventListener('close', finishDialogClose);
      dialog.addEventListener('keydown', function(event) {
        if (usesDialogFallback && event.key === 'Escape') {
          event.preventDefault();
          closeDialog();
          return;
        }

        if (usesDialogFallback && event.key === 'Tab') {
          var focusable = dialogSource && !dialogSource.hidden
            ? [dialogSource, closeButton, dialogVideo]
            : [closeButton, dialogVideo];
          var first = focusable[0];
          var last = focusable[focusable.length - 1];
          if (document.activeElement === dialogTitle) {
            event.preventDefault();
            (event.shiftKey ? last : first).focus();
          } else if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }
      });

      if (typeof ResizeObserver !== 'undefined') {
        resizeObserver = new ResizeObserver(handleScroll);
        resizeObserver.observe(viewport);
      }

      section._socialProofCleanup = function() {
        if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
        if (resizeObserver) resizeObserver.disconnect();
        if (dialog.open) closeDialog();
        delete section.dataset.socialProofInitialized;
        delete section._socialProofCleanup;
      };

      updateControls(0);
    }

    function initAll(container) {
      var scope = container || document;
      if (scope.matches && scope.matches(SECTION_SELECTOR)) {
        initSocialProof(scope);
        return;
      }
      scope.querySelectorAll(SECTION_SELECTOR).forEach(initSocialProof);
    }

    registry.socialProof = initAll;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function(event) {
      initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function(event) {
      var section = event.target.matches(SECTION_SELECTOR)
        ? event.target
        : event.target.querySelector(SECTION_SELECTOR);

      if (section && section._socialProofCleanup) section._socialProofCleanup();
    });
  })();
